export default __webpack_public_path__ + "static/media/TwiterX-ic.8fb247c1.svg";